import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/antd.css";
import "./theme/index.css";

import { Layout } from "antd";
import NavigatorComponent from "./NavigatorComponent";
import { BrowserRouter } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { MixpanelProvider } from "react-mixpanel";
import { UserProvider } from "./UserContext";

// initialize mixpanel
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MixpanelProvider mixpanel={mixpanel}>
      <BrowserRouter>
        <Layout>
          <UserProvider>
            <NavigatorComponent />
          </UserProvider>
        </Layout>
      </BrowserRouter>
    </MixpanelProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
